package br.com.vvrefeicoes.portal.domain.model

enum class GuideStatus {
    RASCUNHO,
    PUBLICADO,
}

enum class GuideContentType {
    TEXT,
    PDF,
    VIDEO,
}

enum class GuideBlockType {
    TEXT,
    IMAGE,
    VIDEO,
    PDF,
}

data class GuideBlock(
    val id: String,
    val type: GuideBlockType,
    val html: String = "",
    val documentId: String = "",
    val caption: String = "",
    val fileName: String = "",
)

data class GuideMedia(
    val id: String,
    val url: String,
    val fileName: String,
    val contentType: String,
    val sizeBytes: Long,
)

data class GuideSummary(
    val id: String,
    val title: String,
    val excerpt: String,
    val status: GuideStatus,
    val contentType: GuideContentType,
    val active: Boolean,
    val version: Int?,
    val createdByName: String?,
    val updatedAt: String?,
    val publishedAt: String?,
)

data class Guide(
    val id: String,
    val title: String,
    val description: String,
    val blocks: List<GuideBlock>,
    val bodyHtml: String,
    val status: GuideStatus,
    val contentType: GuideContentType,
    val active: Boolean,
    val version: Int?,
    val hasPublishedVersion: Boolean,
    val hasDraft: Boolean,
    val allRoles: Boolean,
    val roleIds: List<String>,
    val createdByName: String?,
    val createdAt: String?,
    val updatedByName: String?,
    val updatedAt: String?,
    val publishedAt: String?,
    val publishedByName: String?,
)

data class GuideDraft(
    val title: String,
    val description: String,
    val blocks: List<GuideBlock>,
    val allRoles: Boolean,
    val roleIds: List<String>,
)

data class GuideVersion(
    val id: String,
    val version: Int,
    val title: String,
    val publishedAt: String?,
    val publishedByName: String?,
)

data class GuideRoleRef(
    val id: String,
    val name: String,
)

data class GuidePage(
    val content: List<GuideSummary>,
    val totalPages: Int,
)
